import { ExhibitionModel } from "@api/models/exhibition/ExhibitionModel";
import { PartnerCreateModel } from "@api/models/exhibition/PartnerCreateModel";
import { exhibitionConverter } from "@api/models/objects/Converters";
import { FileRepository } from "@api/repositories/FileRepository";
import { ObjectDataParamsInterface } from "@api/repositories/interfaces/ObjectDataParamsInterface";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { SettingRepository } from "@api/repositories/SettingRepository";
import { renderDescription } from "@share/catalog/helpers/DescriptionGenerator";

interface PartnerCreateServiceInterface {

    languages: string[] | null;

    /**
     * save partner
     */
    save(createModel: PartnerCreateModel, lang: string): Promise<string>;
}

export class PartnerCreateService implements PartnerCreateServiceInterface {

    /**
     *  init service
     */
    constructor(
        private readonly exhibitionSchemaId: string,
        private readonly objectRepository: ObjectRepository,
        private readonly fileRepository: FileRepository,
        public readonly languages: string[]
    ) {
    }

    setDescriptionFields(params: ObjectDataParamsInterface, lang: string) {
        if (!params.fields) {
            return;
        }

        params.fields.description = renderDescription(params.fields as ExhibitionModel, {}, [], lang);

        if (!params.languages) {
            return;
        }

        const languages = Object.keys(params.languages);

        for (let language of languages) {
            params.languages[language].description = renderDescription(params.languages[language] as ExhibitionModel, {iconFileId: params.fields.iconFileId}, [], language);
        }
    }

    async save(createModel: PartnerCreateModel, lang: string) {
        const data = createModel.getFields(lang);
        const params = this.getExhibitionDataParams(createModel, lang);

        const [file, {id}] = await Promise.all([
            //create file
            createModel.iconFile ? this.fileRepository.create(createModel.iconFile as File, createModel.iconFile.name) : null,

            //create partner
            this.objectRepository.create<ExhibitionModel>(this.exhibitionSchemaId, data, exhibitionConverter)
        ]);

        if (file?.id && params.fields) {
            params.fields.iconFileId = file?.id
            this.setDescriptionFields(params, lang);
        }

        // update partner langs fields if languages exists
        if (id && (params.languages || file?.id)) {
            await this.update(id, params);
        }

        return id;
    }

    /**
     * Update partner
     * @param partnerId
     * @param partnerData
     * @returns
     */
    private async update(partnerId: string, partnerData: ObjectDataParamsInterface): Promise<ObjectDataParamsInterface | undefined> {
        return await this.objectRepository.updateV2(this.exhibitionSchemaId, partnerId, partnerData);
    }

    private getExhibitionDataParams(createModel: PartnerCreateModel, lang: string) {
        let languages = createModel.getLanguages(this.languages, lang);
        let fields = createModel.getFields(lang);

        let sessionData: ObjectDataParamsInterface = {
            languages,
            fields
        }

        return sessionData;
    }

}
